import React from 'react'
import Layout from '../../common/Layout'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/administration/unauthorized',
  async action ({ params }) {
    return {
      title: 'Unauthorized',
      component: <Layout containerWell>
        <h1>Unauthorized</h1>
        {/* <p>Cick <a onClick={() => history.push('/adviser/login')}>here</a> to log in.</p> */}
        {/* <p>Cick <a href='/adviser'>here</a> to log in.</p> */}
      </Layout>
    }
  }
}
